import { Attribute, Extension } from '@tiptap/vue-2';

/**
 * A wrapper that sets config for extension attributes
 * for TipTap nodes.
 * @param attribute
 * @returns
 */
export const setAttributeByName = (attribute: string): Record<string, Attribute> => ({
  [attribute]: {
    default: null,
    renderHTML: (attributes) => ({
      [attribute]: attributes[attribute],
    }),
    parseHTML: (element) => element.getAttribute(attribute),
  },
});

export const globalBlacklist = [
  'doc',
  'text',
  'script',
  'style',
];

/**
 * Extension for enabling attributes at a global level.
 * For example, every node should be allowed `style` and `class` attributes.
 * For 'image' and 'table' nodes, permit `align` and `width` attributes.
 * For 'table', allow the `cellpadding` and `cellspacing` attributes (CK Editor legacy support)
 */
export const GlobalAttrsExtension = Extension.create({
  addGlobalAttributes() {
    return [
      {
        types: this.extensions
          .filter((e) => !globalBlacklist.includes(e.name))
          .map((e) => e.name),
        attributes: {
          ...setAttributeByName('style'),
          ...setAttributeByName('class'),
        },
      },
      {
        types: ['image', 'table'],
        attributes: {
          ...setAttributeByName('align'),
          ...setAttributeByName('width'),
        },
      },
      {
        types: ['table'],
        attributes: {
          ...setAttributeByName('cellpadding'),
          ...setAttributeByName('cellspacing'),
          ...setAttributeByName('border'),
        },
      },
      {
        types: [ 'script' ],
        attributes: {
          ...setAttributeByName('async'),
          ...setAttributeByName('defer'),
          ...setAttributeByName('integrity'),
          ...setAttributeByName('nomodule'),
          ...setAttributeByName('referrerpolicy'),
          ...setAttributeByName('src'),
          ...setAttributeByName('type'),
        },
      },

      {
        types: [ 'iframe' ],
        attributes: {
          ...setAttributeByName('allow'),
          ...setAttributeByName('allowfullscreen'),
          ...setAttributeByName('height'),
          ...setAttributeByName('loading'),
          ...setAttributeByName('name'),
          ...setAttributeByName('referrerpolicy'),
          ...setAttributeByName('src'),
          ...setAttributeByName('srcdoc'),
          ...setAttributeByName('width'),
          ...setAttributeByName('title'),
          ...setAttributeByName('frameborder'),
        },
      },

      {
        types: ['style'],
        attributes: {
          ...setAttributeByName('type'),
        },
      },
      {
        types: ['linkBlock'],
        attributes: {
          ...setAttributeByName('href'),
          ...setAttributeByName('hreflang'),
          ...setAttributeByName('target'),
          ...setAttributeByName('referrerpolicy'),
          ...setAttributeByName('rel'),
          ...setAttributeByName('name'),
          ...setAttributeByName('download'),
        },
      },
    ];
  },
});
